import { useState } from 'react';
import { Modal } from 'antd';
import { useCreateTemplate, useUpdateTemplate } from '../../queries/templates';
import { CATEGORY_OPTIONS } from './constants';
import { Field, FieldLabel, Form, FormField, FormRow, Select, TextArea } from '../../components';

const EMPTY = { title: '', body: '', category: 'general', scope: 'team' };

export default function TemplateModal({ template, onClose }) {
  const editing = Boolean(template?._id);
  const [form, setForm] = useState(() =>
    editing ? { title: template.title, body: template.body, category: template.category, scope: template.scope } : EMPTY
  );
  const create = useCreateTemplate();
  const update = useUpdateTemplate();
  const saving = create.isPending || update.isPending;
  const valid = form.title.trim() && form.body.trim();

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const save = () => {
    const options = { onSuccess: onClose };
    if (editing) update.mutate({ _id: template._id, ...form }, options);
    else create.mutate(form, options);
  };

  return (
    <Modal
      open
      title={editing ? 'Edit template' : 'Add template'}
      okText={editing ? 'Save' : 'Create'}
      onCancel={onClose}
      onOk={save}
      confirmLoading={saving}
      okButtonProps={{ disabled: !valid }}
    >
      <Form>
        <FormField>
          <FieldLabel htmlFor="tpl-title">Title</FieldLabel>
          <Field id="tpl-title" placeholder="e.g. Tour confirmation" value={form.title} onChange={set('title')} />
        </FormField>
        <FormRow>
          <FormField>
            <FieldLabel htmlFor="tpl-category">Category</FieldLabel>
            <Select id="tpl-category" value={form.category} onChange={set('category')}>
              {CATEGORY_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </Select>
          </FormField>
          <FormField>
            <FieldLabel htmlFor="tpl-scope">Visibility</FieldLabel>
            <Select id="tpl-scope" value={form.scope} onChange={set('scope')}>
              <option value="team">Shared with the team</option>
              <option value="personal">Only me</option>
            </Select>
          </FormField>
        </FormRow>
        <FormField>
          <FieldLabel htmlFor="tpl-body">Message</FieldLabel>
          <TextArea
            id="tpl-body"
            style={{ minHeight: 120 }}
            maxLength={1600}
            placeholder="Hi {{first_name}}, …"
            value={form.body}
            onChange={set('body')}
          />
        </FormField>
      </Form>
    </Modal>
  );
}
